<script>
  import Fa from 'svelte-fa'
  import { faEnvelope as icon } from '@fortawesome/pro-solid-svg-icons'

  let buttonFocused = $state(false)

  function handleButtonFocus() {
    buttonFocused = true
  }

  function handleButtonBlur() {
    buttonFocused = false
  }

  function handleContactClick() {
    const email = 'insights360@sullivancotter.com'
    const subject = encodeURIComponent('SullivanCotter Feedback - Benchmarks360™ - Enhanced')
    window.location.href = `mailto:${email}?subject=${subject}`
  }
</script>

<div class="contact-actions-container">
  <button
    type="button"
    class="nav-button primary-dark-button text-center inline-flex items-center"
    data-cy="button-contact"
    onfocus={handleButtonFocus}
    onblur={handleButtonBlur}
    onclick={handleContactClick}
  >
    <div class:text-petroleum-500={!buttonFocused} class:text-white={buttonFocused}>
      <Fa class="text-inherit" {icon} />
    </div>
    <span class="ml-2 whitespace-nowrap">Contact us</span>
  </button>
</div>
